import React from "react";
import styles from '../styles/whatIsIt.module.scss';
import '../screens/styles/NewHome.css';
import { Link, NavLink } from "react-router-dom";

function WhatIsIt() {
    return (
        <div className={styles.main}>
            <div className={styles.container}>
                <ul>
                    <li>
                        <p className={styles.question}>What is Ham Yap and how it works?</p>
                        <p className={styles.answer}>Ham Yap contains recipes specially prepared for babies in the supplementary food process and breastfeeding mothers who have allergies such as milk and dairy products allergy, nut allergy or multiple food allergies, which we encounter a lot today. In addition to main meals such as vegetables, cereals, legumes and meat dishes, it also includes different alternative recipes that you can prepare practically, snacks, desserts and diversify your breakfasts.</p>
                    </li>
                </ul>
            </div>
            <br/>
            <br/>
            <br/>
            <div className={styles.container}>
                <ul>
                    <li>
                        <p className={styles.question}>Profile</p>
                        <p className={styles.answer}>You do not need to be a member to see the recipes in the Ham Yap application. However, you must be a member to save the recipes you like so that you can view them again later, and to create a new recipe. To become a member, you must use your Google or Apple account. You must also share your email via Apple Sign In.</p>
                    </li>
                </ul>
            </div>
            <br/>
            <br/>
            <div className={styles.container}>
                <ul>
                    <li>
                        <p className={styles.question}>Filter</p>
                        <p className={styles.answer}>While searching the list, you can mark the foods you are allergic to and view the recipes that do not contain these nutrients automatically filtered.</p>
                    </li>
                </ul>
            </div>
            <br/>
            <br/>
            <div className={styles.container}>
                <ul>
                    <li>
                        <p className={styles.question}>Contact</p>
                        <p className={styles.answer}>If you are accepted to the activity, you can contact the activity owner via your e-mail account.</p>
                    </li>
                </ul>
            </div>
            <br/>
            <br/>
            <div className={styles.container}>
                <ul>
                    <li>
                        <p className={styles.question}>Search Recipes</p>
                        <p className={styles.answer}>In addition to displaying the filtered recipes for you, you can use the search bar to find the recipe you are looking for specifically, or you can find the recipe you want from the category page.</p>
                    </li>
                </ul>
            </div>
            <br/>
            <br/>
            <div className={styles.container}>
                <ul>
                    <li>
                        <p className={styles.question}>My Recipes/ Favorite</p>
                        <p className={styles.answer}>You can save your favorite recipes for later. You can reach the recipes you have created in the 'Own Recipes' tab. You can delete or update recipes you have created. Moreover, you can reach the recipes you like in 'My Favs' tab.</p>
                    </li>
                </ul>
            </div>
            <br/>
            <br/>
            <div className={styles.container}>
                <ul>
                    <li>
                        <p className={styles.question}>Scoring</p>
                        <p className={styles.answer}>You can rate the recipes you like by giving stars and you can create recipes that will earn stars.</p>
                    </li>
                </ul>
            </div>
            <div className={styles.link}>
                <ul>
                    <NavLink to="/privacy" activeClassName="selected">
                        Privacy Statement
                    </NavLink>
                </ul>
            </div>
        </div>
    )
}

export default WhatIsIt